// DashboardHeaderRow.jsx
import React, { useContext } from 'react';

import { makeStyles, TableCell, TableRow, withStyles } from '@material-ui/core';
import { AppStorage } from '../../../../Core/Service/storage-service';
import { BranchFranchiseCompareContext } from './branchServicesProvider';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles({
    mainClass: {
        background: (props) => props.headerBgColor,
        color: (props) => props.headerTextColor
    }
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 12,
        padding: '4px',
        fontWeight: 700,
        border: '1px solid #ccc',
        textTransform: 'uppercase'
    },
    body: {
        fontSize: 12,
        padding: '4px',
        // border: 'none'
        border: '1px solid rgba(0, 0, 0, 0.09)'
        // border: '1px solid #ccc'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);
const DashboardYtdHeaderRow = ({ config }) => {
    const k = config;
    const portalSettings = AppStorage.getPortalSetting();
    const { handleCollaps, Collapse } = useContext(BranchFranchiseCompareContext);

    const classes = useStyles(config);
    let actualAlign = portalSettings.portalSettingMADashboardActualAlign;
    let budgetAlign = portalSettings.portalSettingMADashboardBudgetAlign;
    let varianceAlign = portalSettings.portalSettingMADashboardVarianceAlign;
    let kpiAlign = portalSettings.portalSettingMADashboardKPIsAlign;
    let actualPYAlign = portalSettings.portalSettingMADashboardActualPYAlign;
    let varLYAlign = portalSettings.portalSettingMADashboardVarPYAlign;

    const headerCells = [
        { label: k.actualName, align: actualAlign },
        { label: k.budgetName, align: budgetAlign },
        { label: k.varianceName, align: varianceAlign },
        { label: k.kpIsName, align: kpiAlign },
        { label: k.actualPYName, align: actualPYAlign },
        { label: k.varLYName, align: varLYAlign }
    ];

    return (
        <StyledTableRow>
            <StyledTableCell className={classes.mainClass} align="left">
                {/* <b>{k.categoryName}</b> */}

                <span style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'space-between' }}>
                    <span>
                        <b>{k.categoryName}</b>
                    </span>
                    {config.calculated !== 2 && (
                        <span>
                            {!Collapse[config.categoryId] ? (
                                <abbr title="Collapse">
                                    <ExpandLessIcon style={{ fontSize: 18, cursor: 'pointer' }} onClick={() => handleCollaps(config.categoryId)} />
                                </abbr>
                            ) : (
                                <abbr title="Expand">
                                    <ExpandMoreIcon style={{ fontSize: 18, cursor: 'pointer' }} onClick={() => handleCollaps(config.categoryId)} />
                                </abbr>
                            )}
                        </span>
                    )}
                </span>
            </StyledTableCell>

            {headerCells.map((cell, index) => (
                <StyledTableCell key={`head-1-${index}`} className={classes.mainClass} align={cell.align}>
                    <b>{cell.label}</b>
                </StyledTableCell>
            ))}

            <StyledTableCell
                style={{
                    borderLeft: '2px solid grey'
                }}
                className={classes.mainClass}
                align={k.actualAlign}
            >
                <b>{k.actualName}</b>
            </StyledTableCell>

            {headerCells.map(
                (cell, index) =>
                    index !== 0 && (
                        <StyledTableCell key={`head-2-${index}`} className={classes.mainClass} align={cell.align}>
                            <b>{cell.label}</b>
                        </StyledTableCell>
                    )
            )}
        </StyledTableRow>
    );
};

export default DashboardYtdHeaderRow;
